import { useReports } from 'api/company/useReports'
import { MainPage } from 'components/templates/MainPage'

export const ReportsPage = (): JSX.Element => {
  const { data } = useReports()

  return (
    <MainPage>
      <div className={'space-y-5'}>
        <section
          className={
            'rounded-md bg-gradient-to-r from-slate-700 to-slate-600 p-5 text-white shadow-sm'
          }
        >
          <h2 className={'text-sm font-semibold text-slate-100'}>
            業績サマリー
          </h2>
          <div className={'mt-3 grid grid-cols-2 gap-4 xl:grid-cols-4'}>
            <div>
              <p className={'text-xs text-slate-200'}>年間売上</p>
              <p className={'text-2xl font-bold'}>{data?.summary.sales}</p>
            </div>
            <div>
              <p className={'text-xs text-slate-200'}>目標達成率</p>
              <p className={'text-2xl font-bold'}>
                {data?.summary.achievementRate}
              </p>
            </div>
            <div>
              <p className={'text-xs text-slate-200'}>前年比</p>
              <p className={'text-2xl font-bold'}>{data?.summary.yearOnYear}</p>
            </div>
            <div>
              <p className={'text-xs text-slate-200'}>稼働率</p>
              <p className={'text-2xl font-bold'}>
                {data?.summary.operationRate}
              </p>
            </div>
          </div>
        </section>

        <section className={'grid grid-cols-1 gap-4 xl:grid-cols-3'}>
          {data?.metrics.map((metric) => (
            <div
              key={metric.label}
              className={'rounded-md border bg-white p-4 shadow-sm'}
            >
              <p className={'text-xs text-gray-500'}>{metric.label}</p>
              <p className={'mt-2 text-3xl font-bold text-gray-800'}>
                {metric.value}
              </p>
              <p className={'mt-1 text-xs text-gray-500'}>{metric.note}</p>
              <p className={'mt-2 text-xs font-semibold text-emerald-600'}>
                {metric.trend}
              </p>
            </div>
          ))}
        </section>

        <section className={'rounded-md border bg-white p-4 shadow-sm'}>
          <h2 className={'mb-3 text-base font-bold text-gray-700'}>月次推移</h2>
          <div className={'overflow-x-auto'}>
            <table className={'min-w-full text-sm'}>
              <thead>
                <tr
                  className={
                    'border-b bg-gray-50 text-left text-xs text-gray-600'
                  }
                >
                  <th className={'px-2 py-2'}>月</th>
                  <th className={'px-2 py-2'}>売上</th>
                  <th className={'px-2 py-2'}>目標達成率</th>
                  <th className={'px-2 py-2'}>商談数</th>
                  <th className={'px-2 py-2'}>成約率</th>
                </tr>
              </thead>
              <tbody>
                {data?.monthly.map((month) => (
                  <tr key={month.month} className={'border-b last:border-b-0'}>
                    <td className={'px-2 py-2 font-semibold text-gray-700'}>
                      {month.month}
                    </td>
                    <td className={'px-2 py-2'}>{month.sales}</td>
                    <td className={'px-2 py-2'}>{month.achievementRate}</td>
                    <td className={'px-2 py-2'}>{month.meetings}</td>
                    <td className={'px-2 py-2'}>{month.contractRate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </MainPage>
  )
}
